/**
 * Internal imports
 */
import body from './body';
import html from './html';
/**
 * Adds class to html and Body
 * @ignore
 * @param {string} state - CSS Class\es
 * @return {void}
 */
export default function removeStateClass(state) {
    if (html)
        html.classList.remove(state);
    if (body)
        body.classList.remove(state);
}
